import Mockman from "mockman-js"

function MockAPI() {
  return (
    <div className="MockAPI">
        <Mockman/>
    </div>
  )
}

export default MockAPI